import React, { useState, useEffect, useRef } from "react";

import { Form } from "react-bootstrap";

import Select from "react-select";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

const Support = () => {
  const [optionForTicketCategory, setOptionForTicketCategory] = useState([]);
  const [optionForSubCategory, setOptionForSubCategory] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [ticketError, setTicketError] = useState({});
  const [subCategoryError, setSubCategoryError] = useState({});
  const [customerId, setCustomerId] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileArr, setFileArr] = useState([]);
  const [getSubCategoryLength, setSubCategoryLength] = useState(0);

  const history = useHistory();

  useEffect(() => {
    let userDetails = localStorage.getItem("userDetails");
    let user = JSON.parse(localStorage.getItem("user"));
    setCustomerId(user._id);
    userDetails = JSON.parse(userDetails);
    console.log(userDetails);
    let user_name = userDetails.data.customerId.entityType;
    if (userDetails.data.firstName != null) {
      user_name = userDetails.data.firstName + " " + userDetails.data.lastName;
    }
    if (userDetails.data.email) {
      setUserEmail(userDetails.data.email);
    }
    setUserName(user_name);
    axios
      .get(environment.dap_url + "support/getCategory")
      .then((res) => {
        setOptionForTicketCategory(
          res.data.map((item) => {
            return {
              name: "ticketCategory",
              value: item.categoryName,
              label: item.categoryName,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [data, setData] = useState({
    coustomerName: "",
    ticketCategory: "",
    subCategory: "",
    attachment: "",
    description: "",
  });

  const formValidation = () => {
    const ticketError = {};
    const subCategoryError = {};

    let isValid = true;
    if (!data.ticketCategory) {
      ticketError.error = "Ticket Category is required";
      isValid = false;
    }
    if (!data.subCategory) {
      if (getSubCategoryLength > 0) {
        subCategoryError.error = "Sub Category is required";
        isValid = false;
      }
    }

    setTicketError(ticketError);
    setSubCategoryError(subCategoryError);

    return isValid;
  };

  const handleChange = (selectedOption) => {
    if (selectedOption.name === "ticketCategory") {
      subCategoryRef.current.state.value = "";
      axios
        .get(
          environment.dap_url +
            "support/getSubCategoryByCategory/?categoryName=" +
            selectedOption.value
        )
        .then((res) => {
          console.log(res.data.length);
          setSubCategoryLength(res.data.length);
          setOptionForSubCategory(
            res.data.map((item) => {
              return {
                name: "subCategory",
                value: item.subCategoryName,
                label: item.subCategoryName,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
    setData({ ...data, [selectedOption.name]: selectedOption.value });
  };

  const handleChangeforText = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const subCategoryRef = useRef(null);

  const ticketCategoryRef = useRef(null);

  const descriptionRef = useRef(null);

  const handleCancel = () => {
    setData({
      coustomerName: "",
      ticketCategory: "",
      subCategory: "",
      attachment: "",
      description: "",
    });
    setUploadFiles([]);
    ticketCategoryRef.current.state.value = "";
    subCategoryRef.current.state.value = "";
    descriptionRef.current.value = "";
    inputRef.current.value = "";

    history.push("/my-supports");
  };

  const inputRef = useRef(null);
  const handleChangeForFile = (e) => {
    console.log(e.target.name);
    const file = e.target.files[0];
    const f = [...fileArr];
    const uploadFile = [...uploadFiles];
    uploadFile.push(file);
    f.push(URL.createObjectURL(e.target.files[0]));
    setFileArr(f);
    setUploadFiles(uploadFile);
    setData({ ...data, [e.target.name]: uploadFile });
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    const isValid = formValidation();
    let user = JSON.parse(localStorage.getItem("user"));
    if (isValid) {
      setLoading(true);

      const formData = new FormData();
      formData.append("role_type", "CUSTOMER");
      formData.append("customerId", customerId);
      formData.append("customerEmail", userEmail);
      // formData.append("assignedTo","");
      formData.append("ticketCategory", data.ticketCategory);
      formData.append("subcategory", data.subCategory);
      formData.append("description", data.description);
      formData.append("createdBy", user._id);
      formData.append("parentId", user.parentId);

      let attachmentArr = [];
      for (let i = 0; i < uploadFiles.length; i++) {
        formData.append("attachment", uploadFiles[i]);
      }
      formData.append("attachment", attachmentArr);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      for (let [k, v] of formData.entries()) {
        console.log(k, v);
      }
      console.log(formData);

      axios
        .post(
          environment.dap_url + "support/createByCustomer",
          formData,
          config
        )
        .then((res) => {
          console.log("ticket", res);
          Swal.fire({
            icon: "success",
            title: "Ticket Created Successfully",
            showConfirmButton: false,
            timer: 1500,
          }).then((result) => {
            history.push("/my-supports");
            // window.location.href("supports");
            // handleCancel();
          });
        })
        .catch((err) => {
          console.log(err);
        });
      // handleCancel();
    } else {
      e.preventDefault();
      setLoading(false);
    }
  };

  const remove = (e, i) => {
    console.log(i);
    let f = [...fileArr];
    const uploadFile = [...uploadFiles];
    uploadFile.splice(i, 1);
    setUploadFiles(uploadFile);
    f.splice(i, 1);
    console.log(f);
    setFileArr(f);
    setData({ ...data, ["attachment"]: uploadFile });
  };

  return (
    <div className="mx-3 bg-white p-3">
      <div className="row" style={{ marginTop: "75px", color: "black" }}></div>

      <div>
        <div className="row">
          <div className="col-12">
            {/* <div className="card">
                            <div className="card-body"> */}
            <h4 className="card-title">Report an issue :</h4>
            {/* </div>
                        </div> */}
          </div>
        </div>
      </div>
      <div style={{ marginLeft: "4%", marginRight: "4%" }}>
        <Form encType="multipart/form-data" onSubmit={handelSubmit}>
          <div className="row">
            <div className="col-6">
              <Form.Group>
                <Form.Label>Customer Name:</Form.Label>
                <Form.Control value={userName} disabled />
              </Form.Group>
            </div>
            <div className="col-6">
              <Form.Group>
                <Form.Label>Email:</Form.Label>
                <Form.Control value={userEmail} disabled />
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <Form.Group>
                <Form.Label>Date: </Form.Label>
                <Form.Control
                  value={new Date().toLocaleDateString()}
                  disabled
                />
              </Form.Group>
            </div>

            <div className="col-4">
              <Form.Group>
                <Form.Label>Ticket Category:</Form.Label>
                <Select
                  ref={ticketCategoryRef}
                  onChange={handleChange}
                  options={optionForTicketCategory}
                />
                <div>
                  {Object.keys(ticketError).map((key) => {
                    return <p style={{ color: "red" }}>{ticketError[key]}</p>;
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-4">
              <Form.Group>
                <Form.Label>Sub Category:</Form.Label>
                <Select
                  ref={subCategoryRef}
                  onChange={handleChange}
                  options={optionForSubCategory}
                />
                <div>
                  {Object.keys(subCategoryError).map((key) => {
                    return (
                      <p style={{ color: "red" }}>{subCategoryError[key]}</p>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
          {/* //attachment */}
          <div className="row">
            <div className="col-3">
              <Form.Group>
                <Form.Label>Attachment:</Form.Label>
                <br></br>
                <input
                  onChange={handleChangeForFile}
                  ref={inputRef}
                  name="attachment"
                  type="file"
                  id="formFileMultiple"
                  multiple
                  accept="image/png, image/gif, image/jpeg,image/svg"
                  style={{ display: "none" }}
                />
                <Form.Label htmlFor="formFileMultiple">
                  <button
                    type="button"
                    class="btn btn-primary"
                    onClick={() => inputRef.current.click()}
                    style={{ margin: "5px" }}
                  >
                    Add Pictures
                  </button>
                </Form.Label>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px",
                  }}
                >
                  {fileArr.map((f, i) => (
                    <div
                      style={{
                        width: "100px",
                        margin: "5px",
                        border: "1px solid black",
                        position: "relative",
                      }}
                    >
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={(e) => remove(e, i)}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                        }}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                      <img src={f} style={{ width: "100px", height: "100px", objectFit: "cover" }} />
                    </div>
                  ))}
                </div>
              </Form.Group>
            </div>
            {/* <div className="col-3">
                            <Form.Group >
                            </Form.Group>
                        </div> */}
          </div>

          <div className="row">
            <div className="col-12">
              <Form.Group>
                <Form.Label> Description:</Form.Label>
                <textarea
                  onChange={handleChangeforText}
                  ref={descriptionRef}
                  name="description"
                  class="form-control"
                  rows="3"
                ></textarea>
              </Form.Group>
            </div>
          </div>
          <div className="col-4" style={{ marginTop: "2%" }}>
            <button type="submit" class="btn btn-primary">
              CREATE
            </button>
            {/* <button onClick={handleCancel} type="button" class="btn btn-danger">
                            CANCEL
                        </button> */}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Support;
